<div class="toast-stack" role="alert" aria-live="polite" aria-atomic="false">
  @for (toast of toastService.toasts(); track trackById($index, toast)) {
    <div class="toast toast--{{ toast.type }}" [attr.data-testid]="'toast-' + toast.id">
      <span class="toast__icon material-icons-round">{{
        iconMap[toast.type]
      }}</span>
      <p class="toast__message" [attr.data-testid]="'toast-message-' + toast.id">{{ toast.message }}</p>
      <button
        class="toast__close"
        type="button"
        aria-label="Dismiss notification"
        (click)="toastService.dismiss(toast.id)"
        [attr.data-testid]="'toast-close-btn-' + toast.id"
      >
        <span class="material-icons-round">close</span>
      </button>
      <span
        class="toast__bar"
        [style.animation-duration.ms]="toast.duration"
      ></span>
    </div>
  }
</div>
